import {
  call,
  takeLatest
} from "redux-saga/effects";
import {
  downloadXLSFile
} from "utils/api";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";
import {
  defaultReturn,
  makePayload,
  requestSaga,
  subKeySaga,
  fillDictionary,
  generateDefaultActions
} from "store/utils/helpers";

export const RECALCULATE_ALL_PORTFOLIOS = generateDefaultActions("RECALCULATE_ALL_PORTFOLIOS");
export const recalculateAllPortfolios = payload => makePayload(RECALCULATE_ALL_PORTFOLIOS.value, payload);
function* recalculateAllPortfoliosSaga(payload) {
  const url = "/servermetrics/all";
  yield requestSaga(RECALCULATE_ALL_PORTFOLIOS, url);
}

export const RECALCULATE_PORTFOLIO = generateDefaultActions("RECALCULATE_PORTFOLIO");
export const recalculatePortfolio = payload => makePayload(RECALCULATE_PORTFOLIO.value, payload);
function* recalculatePortfolioSaga(payload) {
  const url = `/servermetrics/loan?companyId=${payload.companyId}`;
  const requestSaga = subKeySaga(payload.subKey, () => {
    ToastSuccess(`Calculating metrics for ${payload.companyName}`);
  });
  yield requestSaga(RECALCULATE_PORTFOLIO, url);
}

const initialState = {
  recalculateAllPortfolios: {

  },
  recalculatePortfolio: {

  }
};

export default function metricsReducer(state = initialState, action) {
  const {
    type,
    payload,
    subKey
  } = action;
  switch (type) {
    case RECALCULATE_ALL_PORTFOLIOS.success:
      ToastSuccess("Recalculating all portfolios");

      return defaultReturn(state, payload.data, "recalculateAllPortfolios");
    case RECALCULATE_ALL_PORTFOLIOS.failure:
      ToastError("Could not recalculate all portfolios");

      return state;
    case RECALCULATE_PORTFOLIO.success:
      return fillDictionary(state, payload.data, "recalculatePortfolio", subKey);
    default:
      return state;
  }
}

export function* metricsSaga() {
  yield takeLatest(RECALCULATE_ALL_PORTFOLIOS.value, recalculateAllPortfoliosSaga);
  yield takeLatest(RECALCULATE_PORTFOLIO.value, recalculatePortfolioSaga);
}
